// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"660a9062","856":"71e1c177","952":"2544d01f"}[chunkId] + ".chunk.js";
};